exports.onClientEntry = () => {
	/**
   * Adicionando botão flutuando nas tags via scrip do estaticos
   * @task - SA-240
   */
  const scripts = [
    "https://estaticos.novaescola.org.br/chat-wpp-popover.js",
    "https://estaticos.novaescola.org.br/localizacao-popup.js",
    "https://estaticos.novaescola.org.br/whatsapp-popover.js",
  ];

  scripts.forEach(src => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true;

    if (src.includes("whatsapp-popover")) {
      script.setAttribute("data-event", "tudo-sobre");
      script.setAttribute("data-project", "SITE");
      script.setAttribute("data-href", "https://api.whatsapp.com/send/?phone=5511999732391&text=Oi%2C+vim+do+site+planejar+minhas+aulas&type=phone_number&app_absent=0");
    }

    document.body.appendChild(script);
  });

  const audimaScript = document.createElement("script");
  audimaScript.src = "https://menu.audima.co/accessibility.js?position=bottomRight";
  audimaScript.onload = () => {
    const checkBtn = setInterval(() => {
      const audimaBtn = document.querySelector("#accessibility-menu");
      if (audimaBtn) {
        audimaBtn.style.bottom = "170px";
        clearInterval(checkBtn);
      }
    }, 50);
  };

  audimaScript.defer = true;
  document.body.appendChild(audimaScript);

	document.cookie = `ane_redirect=${window.location.href};path=/;max-age=900000;domain=.${window.location.hostname}`;
};

exports.onRouteUpdate = ({ location }) => {
	document.cookie = `ane_redirect=${location.href};path=/;max-age=900000;domain=.${location.hostname}`;
}
